export default __webpack_public_path__ + "static/grouped-bar-5f8d6f6cd899a97a7fe164aec27049e4.png";